<template>
    <!--Le code HTML dans la balise template-->
    <div>
        <v-sheet class="pa-12" style="background-color: #01358D;" rounded>
            <v-card class="form-inscription mx-auto px-6 py-8" align-content="">
                <v-form style="width:auto;" validate-on="submit lazy" @submit.prevent="inscription">
                    <v-row>
                        <v-col cols="12"
                               md="4">
                            <v-text-field v-model="utilisateur.RPPS" label="RPPS" required hide-details>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12"
                               md="4">
                            <v-text-field v-model="utilisateur.nom"
                                          :rules="nameRules"
                                          :counter="10"
                                          label="Nom"
                                          required
                                          hide-details></v-text-field>
                        </v-col>

                        <v-col cols="12"
                               md="4">
                            <v-text-field v-model="utilisateur.prenom"
                                          :rules="nameRules"
                                          :counter="10"
                                          label="Prénom"
                                          hide-details
                                          required></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12"
                               md="4">
                            <v-text-field v-model="utilisateur.tel"
                                          :counter="10"
                                          label="Numéro de téléphone"
                                          hide-details
                                          required></v-text-field>
                        </v-col>
                        <v-col cols="12"
                               md="4">
                            <label style="margin:0;"> Adresse de facturation</label>
                            <select class="classic" @change="adresseFacturationHasChanged">
                                <option v-if="!utilisateur.lesCabinets">Aucune adresse de facturation ne peut être sélectioné</option>
                                <option v-else  v-for="(cabinet,index) in utilisateur.lesCabinets" :value="index"> {{ cabinet.adresse }}</option>
                            </select>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field v-if="utilisateur.selectedCabinet"
                                          v-model="utilisateur.selectedCabinet.idFacturation"
                                          label="Identifiant de facturation"

                                          readonly>

                            </v-text-field>
                        </v-col>
                    </v-row>
                    <row>
                        Adresse
                    </row>
                    <v-row>
                        <v-col 
                               >
                            <v-text-field v-model="utilisateur.adresse1.numEtNomVoie"
                                          label="Numéro et nom de la voie"
                                          hide-details
                                          required>
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col  cols="12"
                               md="4">
                            <v-text-field v-model="utilisateur.adresse1.ville"
                                          label="Ville"
                                          hide-details
                                          required>

                            </v-text-field>
                        </v-col>
                        <v-col  cols="12"
                               md="4">
                            <v-text-field v-model="utilisateur.adresse1.codePostal"
                                          label="Code postal"
                                          hide-details
                                          required>

                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12"
                               md="4">
                            <v-text-field v-model="utilisateur.email"
                                          :rules="emailRules"
                                          label="E-mail"
                                          hide-details
                                          required></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12"
                               md="4">
                            <v-text-field label="Mot de passe"
                                          v-model="utilisateur.mdp"
                                          :rules="passwordRules"
                                          :error-messages="Erreur"
                                          type="password"
                                          required></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="4" v-if="error==4">
                            Vous êtes déjà inscrit
                            <router-link :to="{name: 'Accueil'}" :tag="div" class=".custom-link">Connectez vous</router-link>
                        </v-col>
                    </v-row>
                    <v-row v-if="messageErreurInscription">
                        <v-col cols="12">
                            <v-alert type="error" variant="tonal" density="compact" border="start">
                                {{ messageErreurInscription }}
                            </v-alert>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-btn type="submit"
                               :loading="loading"
                               block
                               color="success"
                               size="large"
                               variant="elevated"
                               @click="">
                            S'inscrire
                        </v-btn>
                    </v-row>
                    <p style="margin-top:15px;text-align:center;">
                        Déjà un compte ?
                        <router-link style="color:#000000DE;display:inline;text-decoration:underline;" to="/" tag="a">
                            Connectez vous !
                        </router-link>
                    </p>
                </v-form>
            </v-card>

        </v-sheet>
    </div>

    <div class="text-center pa-4">
        <v-dialog v-model="dialog"
                  max-width="400px">
            <template v-slot:activator="{ props: activatorProps }">
                <v-card title="">
                    <v-card-actions class="justify-center">
                        <v-btn v-bind="activatorProps" style="background-color: #ffc0cb">
                            S'inscrire avec la carte CPS
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </template>

            <v-card  prepend-icon="mdi-map-marker"
                    title="S'inscrire avec la carte CPS" subtitle="Carte CPS">
                <div v-if="currentFormCPS ==0" style="width:100%;padding:15px; text-align:center;">
                    <p>Veuillez saisir votre code CPS</p>
                    <v-text-field v-model="codeCPS"
                                  placeholder="Code CPS"
                                  variant="outlined"
                                  @keyup.enter="validerCodeCPS">
                    </v-text-field>
                    <p v-if="getErreurCodeCPS" class="text-danger"> Code CPS incorrect</p>
                </div>
                <p v-if="currentFormCPS == 0" style="text-align: center;">Nombre de tentatives restantes : {{getNbTentativeDuCodeCPS}}</p>
                <template v-if="currentFormCPS ==0" v-slot:actions>

                    <v-spacer></v-spacer>
                    <button @click="dialog = false" type="button" class="btn btn-danger" style="margin-right:7px;">
                        Annuler
                    </button>

                    <button @click="validerCodeCPS" type="button" class="btn btn-primary">
                        Confirmer
                    </button>
                </template>
            </v-card>
            <v-card v-if="currentFormCPS == 1"
                    title="S'inscrire avec la carte CPS"
                    subtitle="Renseigner le mail et mot de passe">
                <div style="margin : 7px;">
                    <form>
                        <v-text-field class="text-field-utilisateurCPS"
                                      v-model="utilisateurCPS.email"
                                      :rules="emailRules"
                                      label="E-mail"
                                      hide-details
                                      required>
                        </v-text-field>
                        <v-text-field class="text-field-utilisateurCPS"
                                      label="Mot de passe"
                                      v-model="utilisateurCPS.password"
                                      :rules="passwordRules"
                                      :error-messages="Erreur"
                                      type="password"
                                      required>
                        </v-text-field>
                        <v-text-field class="text-field-utilisateurCPS"
                                      label="Confirmation du mot de passe"
                                      v-model="utilisateurCPS.confirmPassword"
                                      :rules="passwordRules"
                                      :error-messages="Erreur"
                                      type="password"
                                      required>
                        </v-text-field>
                    </form>
                </div>
                <template v-slot:actions>

                    <v-spacer></v-spacer>
                    <button @click="" type="button" class="btn btn-danger" style="margin-right:7px;">
                        Plus tard
                    </button>

                    <button @click="" type="button" class="btn btn-primary">
                        Confirmer
                    </button>
                </template>
            </v-card>
        </v-dialog>
    </div>
</template>
<style>
    .form-inscription{
        width:50%;
    }

    .custom-link {
        /* Ajoute ici ton style personnalisé pour le lien */
        color: red;
        text-decoration: underline;
        cursor: pointer;
    }

    .form-container {
        max-width: 600px;
        margin: auto;
    }
    .text-field-utilisateurCPS{
        margin : 17px;
    }
     /*Select for adresse de facturation*/
    select {
        /* styling */
        background-color: white;
        border: thin solid blue;
        border-radius: 4px;
        display: inline-block;
        font: inherit;
        line-height: 1.5em;
        /*padding: 0.5em 3.5em 0.5em 1em;*/
        /* reset */

        margin: 0;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        -webkit-appearance: none;
        -moz-appearance: none;
    }
    select.classic {
      background-image:
        linear-gradient(45deg, transparent 50%, blue 50%),
        linear-gradient(135deg, blue 50%, transparent 50%),
        linear-gradient(to right, skyblue, skyblue);
      background-position:
        calc(100% - 20px) calc(1em + 2px),
        calc(100% - 15px) calc(1em + 2px),
        100% 0;
      background-size:
        5px 5px,
        5px 5px,
        2.5em 2.5em;
      background-repeat: no-repeat;
    }

    select.classic:focus {
      background-image:
        linear-gradient(45deg, white 50%, transparent 50%),
        linear-gradient(135deg, transparent 50%, white 50%),
        linear-gradient(to right, gray, gray);
      background-position:
        calc(100% - 15px) 1em,
        calc(100% - 20px) 1em,
        100% 0;
      background-size:
        5px 5px,
        5px 5px,
        2.5em 2.5em;
      background-repeat: no-repeat;
      border-color: grey;
      outline: 0;
    }

    @media (max-width: 650px) {
        .form-inscription{
            width : auto;
        }
    }

</style>
<script>
    import { defineComponent } from 'vue';
    import config from '../config';
    import RequestManager from '../script/request';
    import { mapGetters } from 'vuex';
import Connexion from '../script/Connexion';

    //import bcrypt from 'bcrypt';
    //const crypto = require('crypto');
    export default defineComponent({
        components: {
            //Les composants
        },
        // Données du composant
        data: function () {
            return {
                ErreurCodeCPS: null,
                codeCPS: null,
                message: 'Bienvenue dans la vue inscription',
                dialog: false,
                utilisateur: {
                    nom: "",
                    prenom: "",
                    RPPS : "",
                    adresse1: {
                        numEtNomVoie: "",
                        ville : "",
                        codePostal : "",
                    },
                    email: "",
                    mdp: "",
                    tel: "",
                    confirmMdp: "",
                },
                utilisateurCPS : {
                    email: '',
                    password: '',
                    confirmPassword: '',
                    showPassword: false,
                    showConfirmPassword: false,
                    RPPS : '',
                },
                currentFormCPS : 0,
                error: null,
                messageErreurInscription: ""
            }
        },
        //Données calculées du composant
        computed: {
            lesAdressesCabinets() {
                if (this.utilisateur.hasOwnProperty('lesCabinets'))
                    return this.utilisateur.lesCabinets.map(cabinet => cabinet.adresse);
                else
                    return [];
            },
            cabinets() {
                let lesCabinets = [];
                if (this.getCartePS != null) {
                    console.log("this.getCartePS != null");
                    for (let i = 1; i < this.getCartePS.length; i++) {
                        console.log("i < this.getCartePS.length");
                        console.log("this.getCartePS[i] = ",this.getCartePS[i])
                        if (this.getCartePS[i].hasOwnProperty('group')) {
                            console.log("this.getCartePS[i].hasOwnProperty('groups')");
                            if (this.getCartePS[i].group == 2) {
                                console.log("this.getCartePS[i].group == 2")
                                let unCabinet = {
                                    idFacturation: this.getCartePS[i].Fields[8],
                                    adresse: this.getCartePS[i].Fields[7]
                                }
                                lesCabinets.push(unCabinet);
                            }
                            // On arrête de chercher dès qu'on tombe sur un group != 2
                            else
                                break;
                        }
                    }
                }
                console.log("lesCabinets = ", lesCabinets);
                return lesCabinets;
            },
            getCartePS() {
                return this.$store.getters['Cartes/getCarteCPS']
            },
            getErreurCodeCPS() {
                return this.$store.getters['Cartes/getErreurCodeCPS'];
            },
            getNbTentativeDuCodeCPS() {
                return this.$store.getters['Cartes/getNbTentativeDuCodeCPS'];
            },
            getCabinets() {
                let lesCabinets = [];
                if (this.getCartePS) {
                    for (var i = 0; i < this.getCartePS[1].Fields.length; i++) {
                        lesCabinets.push(this.getCartePS[1].Fields[i]);
                    }
                }
                console.log("lesCabinets = ", lesCabinets);
                return lesCabinets;
            }
            //données calculées
        },
        //Méthodes et fonctions du
        methods: {
            adresseFacturationHasChanged(event) {
                let indexOfCabinet = event.target.value;
                this.initUtilisateurAdresseWithIndexOfCabinet(indexOfCabinet);
            },
            initUtilisateurAdresseWithIndexOfCabinet(indexOfCabinet) {
                this.utilisateur.selectedCabinet = this.utilisateur.lesCabinets[indexOfCabinet];
                let numEtNomVoie = this.utilisateur.lesCabinets[indexOfCabinet].adresse;
                let ville = this.utilisateur.lesCabinets[indexOfCabinet].ville;
                let codePostal = this.utilisateur.lesCabinets[indexOfCabinet].cp;
                this.utilisateur.adresse1 = {
                    numEtNomVoie: numEtNomVoie,
                    ville: ville,
                    codePostal: codePostal,
                }
            },
            faireCorrespondreIdentifiantDeFacturationAvecIdentifiantdeStructure(idStruct) {
                for (let i = 1; i < this.getCartePS.length; i++) {
                    let cabinetInCartePS = this.getCartePS[i];
                    if (cabinetInCartePS.group == 2) {
                        let idStrucDansCartePS = cabinetInCartePS.Fields[5] + cabinetInCartePS.Fields[6];
                        let idFacturation = cabinetInCartePS.Fields[8] + cabinetInCartePS.Fields[9];
                        this.utilisateur.lesCabinets.forEach((cabinet) => {
                            if (cabinet.identifiantStructure == idStrucDansCartePS) {
                                cabinet.idFacturation = idFacturation;
                            }
                        })
                    }
                }
                this.utilisateur.lesCabinets.forEach((cabinet) => {
                })
            },
            async setUtilisateurByCPS(CPS) {
                let utilisateur = {
                    nom: CPS[0].Fields[5],
                    prenom: CPS[0].Fields[6],
                    // Format PSC classique = type identifiant (Fields[1], "8" pour RPPS)
                    // concatene au RPPS (Fields[2]) -> ex : "8" + "99700723077" = "899700723077"
                    RPPS: `${CPS[0].Fields[1]}${CPS[0].Fields[2]}`,
                    adresse1: {
                        numEtNomVoie: "",
                        nomVoie: "",
                        ville: "",
                        codePostal: "",
                    },
                    email: "",
                    mdp: "",
                    tel: "",
                    confirmMdp: "",
                    lesCabinets: [],
                    selectedCabinet: null,
                };


                try {
                    const response = await Connexion.getInfosPSIdent(utilisateur.RPPS);
                    //console.log("response await Connexion.getInfosPSIdent(utilisateur.RPPS) = ", response);

                    // L'annuaire peut ne rien renvoyer (identifiant absent de PsBase.mdb,
                    // base non montee...). On garde alors nom/prenom/RPPS lus sur la CPS
                    // sans planter, plutot que de deref response[0] sur un tableau vide.
                    if (!Array.isArray(response) || response.length === 0) {
                        console.warn("getInfosPSIdent : aucun cabinet retourne pour l'identifiant", utilisateur.RPPS);
                        utilisateur.lesCabinets = [];
                        this.utilisateur = utilisateur;
                        return;
                    }

                    //alert("Après await Connexion.getInfosPSIdent(utilisateur.RPPS);");
                    utilisateur.lesCabinets = response;
                    utilisateur.tel = response[0].tel
                    utilisateur.email = response[0].mail
                    this.utilisateur = utilisateur
                    this.initUtilisateurAdresseWithIndexOfCabinet(0);
                    this.faireCorrespondreIdentifiantDeFacturationAvecIdentifiantdeStructure();
                    //console.log("utilisateur = ", utilisateur);
                    //alert("Fin de Inscription.vue.setUtilisateurByCPS()")
                } catch (error) {
                    console.error('Erreur lors de la récupération des informations des cabinets :', error);
                }
            },
            validerCodeCPS() {
                //if (this.codeCPS == null || this.codeCPS == "") {
                //    this.ErreurCodeCPS = true;
                //}
                //else {
                //    RequestManager.EnvoyerMessageWebView({ action: "LireCartePS", parameters: [this.codeCPS] });
                //}
                RequestManager.EnvoyerMessageWebView({ action: "LireCartePS", parameters: [this.codeCPS, "inscription"] });
            },
            inscriptionAvecCPS() {
                this.inscriptionSansCPS();
            },
            inscription() {
                if (this.cpsChargéAvecSuccé)
                    this.inscriptionAvecCPS();
                else
                    this.inscriptionSansCPS();
            },
            inscriptionSansCPS() {
                //alert("Inscription Sans CPS")
                var url = `${config.urlBackEndParent}api/Client/inscription/`;
                console.log('url = ' + url);
                //var data = {
                //    "nom": "string",
                //    "pseudo": "string",
                //    "prenom": "string",
                //    "email": "string",
                //    "mdp": "string",
                //    "adresse1": "string",
                //    "tel": "string",
                //    "id": 0
                //}
                const data = { ...this.utilisateur };
                data.adresse1 = this.utilisateur.adresse1.numEtNomVoie ;
                data.ville = this.utilisateur.adresse1.ville;
                data.code_postal = this.utilisateur.adresse1.codePostal;
                console.log("utilisateur = ", this.utilisateur);
                console.log("data = ", data);
                // Reset des erreurs affichees avant chaque tentative
                this.error = null;
                this.messageErreurInscription = "";
                RequestManager.post(url, data)
                    .then(response => {
                        switch (response.numRes) {
                            case 1:
                                //console.log('Utilisateur ajouté avec succès');
                                this.$router.push({ name: 'InscriptionReussit' });
                                break;
                            case 2:
                                console.log('Ajout dans la base de données échoué');
                                this.messageErreurInscription = "Échec de l'enregistrement dans la base de données. Veuillez réessayer.";
                                break;
                            case 3:
                                console.log('Adresse email incorrecte');
                                this.messageErreurInscription = "Adresse email incorrecte.";
                                break;
                            case 4:
                                this.error = 4
                                console.log('Utilisateur déjà inscrit');
                                break;
                            default:
                                console.log('response = ', response);
                                console.log('Code de réponse non reconnu');
                                this.messageErreurInscription = "Une erreur inattendue est survenue lors de l'inscription (code " + response.numRes + ").";
                                break;
                        }
                    })
                    .catch(error => {
                        console.log("Erreur dans le composant Inscription.inscription()");
                        console.log(error);
                        this.messageErreurInscription = "Impossible de contacter le serveur. Vérifiez votre connexion et réessayez.";
                    });
                
            },

            async hashPassword(plainPassword, saltRounds) {
                const hashedPassword = crypto.createHash('sha256').update(plainPassword).digest('hex');
                console.log('Mot de passe haché :', hashedPassword);
            }
        },

        // Variables  passées en paramétre
        props: {

        },
        // fonction s'éxécurant lorsque le composant est monté
        // elle est exécuté avant la création du composant
        mounted() {

        }
        ,
        // fonction s'éxécurant lorsque le composant est crée
        // elle est exécuté avant le rendu du composant
        created() {

        },
        watch: {
            getCartePS(newCartePS) {
                if (newCartePS != "" && newCartePS != null) {
                    this.setUtilisateurByCPS(newCartePS);
                    this.dialog = false;
                    this.cpsChargéAvecSuccé = true;
                    //alert("Carte CPS non vide !!!")
                }
                else {
                    this.$store.commit('Cartes/decrementerNbTentativeDuCodeCPS')
                    //alert("newCarteCPS null ou vide")
                }
                console.log('newCartePS = ', newCartePS);
            },
            getNbTentativeDuCodeCPS(newValue) {
                if (newValue == 0) {
                    alert("Vous n'avez plus de tentive, votre carte est bloquée");
                }
            },
            getErreurCodeCPS(newValue) {
                if (newValue) {
                    alert('On a bien lu la carte');
                }
            },
            dialog(newValue){
                //if (!newValue) {
                //    this.ErreurCodeCPS = false;
                //}
            }
        }
    });
</script>
